import ScanReviewRequestClient from "@/clients/duallo/ScanReviewRequestClient";

class ScanReviewRequestService {

    async getReviewRequests(status = null) {
        return await ScanReviewRequestClient.getReviewRequests(status);
    }

    async getPendingReviewRequests() {
        return await ScanReviewRequestClient.getReviewRequests("Pending");
    }
}

export default new ScanReviewRequestService();
